import React from "react";
import { Create, translate } from "react-admin";
import AreainfoForm from "./AreainfoForm";

const AreainfoTitle = ({ translate }) => {
  return <span>{`สร้าง${translate("areainfo.areainfo")}`}</span>;
};

const Title = translate(AreainfoTitle);

export const AreainfoCreate = props => (
  <Create title={<Title />} {...props}>
    <AreainfoForm />
  </Create>
);



// WEBPACK FOOTER //
// ./src/components/areainfo/AreainfoCreate.js